@if (loading || (!formLoaded)) {
  <kendo-loader type="converging-spinner" size="large" style="margin: auto;"></kendo-loader>
}
@if (!loading && formLoaded) {
  <div class="container-fluid mt-4">
    <div class="d-flex">
      <div class="ms-auto">
        @if (canCreateWellViewProject) {
          <button type="button" kendoButton themeColor="primary" (click)="createWellViewProject()">Create Well View Project</button>
        }
      </div>
    </div>
    <!--<div>Invalid: {{ProjectHeaderForm.invalid}}, FormLoaded:{{formLoaded}}</div>-->
    @if (ProjectHeaderForm.invalid && ProjectHeaderForm.dirty && formLoaded && !ResettingForm && !ProcessingForm) {
      <div class="alert alert-danger alert-dismissible fade show" role="alert">
        <ul class="mb-0">
          <li [hidden]="ProjectHeaderForm.controls['Name'].valid || ProjectHeaderForm.controls['Name'].pristine">A Valid Project Name (5-69 chars, exlcuding / \ : * ? " > |) must be provided.</li>
          <li [hidden]="!ProjectHeaderForm.controls['Name'].errors?.invalidCharacters">Special characters are not allowed.</li>
          <li [hidden]="!ProjectHeaderForm.controls['ProjectDescription'].errors?.invalidCharacters">Special characters are not allowed.</li>
          <li [hidden]="!ProjectHeaderForm.controls['Location'].errors?.invalidCharacters">Special characters are not allowed.</li>
          <li [hidden]="!ProjectHeaderForm.controls['ProjectEconomics'].errors?.invalidCharacters">Special characters are not allowed.</li>
          <li [hidden]="!ProjectHeaderForm.controls['Prospect'].errors?.invalidCharacters">Special characters are not allowed.</li>
          <li [hidden]="!ProjectHeaderForm.controls['ProjectDescription'].errors?.invalidDescriptionLength">The Project Description must not exceed 250 characters and must not include invalid characters.</li>
          <li [hidden]="ProjectHeaderForm.controls['ExploreDevelopIds'].valid">Explore / Develop must be selected.</li>
          <li [hidden]="ProjectHeaderForm.controls['AfeApprovalTeam'].valid">A WBS Approval Team must be selected.</li>
          @if (projectTab().ProjectTypeId === ProjectTypeId.TankBattery) {
            <li [hidden]="ProjectHeaderForm.controls['BatteryDesignTypeIds'].valid">A Battery Design Type must be selected.</li>
          }
        </ul>
        <!-- FOR DEBUGGING FORM ERRORS
        <button type="button" (click)="showValidationErrors()">Show Form Errors</button>
        @if (showingValidationErrors) {
        <ul class="mb-0">
          <li *ngFor="let error of ValidationErrors">{{error.name}}={{error.value}}</li>
        </ul>
        }
        -->
      </div>
    }
    <form novalidate [formGroup]="ProjectHeaderForm">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="wbsNumber">WBS Number</label>
            <kendo-textbox id="wbsNumber" class="k-textbox form-control" formControlName="WBSNumber" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="wbsType">WBS Type</label>
            <kendo-textbox id="wbsType" class="k-textbox form-control" formControlName="WBSType" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="wbsSubType">WBS Sub Type</label>
            <kendo-textbox id="wbsSubType" class="k-textbox form-control" formControlName="WBSSubType" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label>Project ID</label>
            <kendo-textbox class="k-textbox form-control" [disabled]="true" value="{{projectId | kendoNumber:'000000'}}" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="projectName">Project Name</label>
            <kendo-textbox id="projectName" class="k-textbox form-control" formControlName="Name" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="projectStatus">Project Status</label>
            <kendo-combobox id="projectStatus" class="form-control" formControlName="ProjectStatus" [data]="dComboBoxProjectStatus" [textField]="'Description'" [valueField]="'ProjectStatusId'" [placeholder]="placeHolderProjectStatus" [itemDisabled]="projectStatusDisabled" [clearButton]="false" (valueChange)="handleProjectStatusChange($event)" [disabledControl]="projectStatusListDisabled()">
            </kendo-combobox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="ExploreDevelopIds">Explore / Develop</label>
            <kendo-combobox id="ExploreDevelopIds" class="form-control" formControlName="ExploreDevelopIds" [data]="FilteredExploreDevelopIds" [textField]="'name'" [disabledControl]="!(fieldVisibility.ExploreDevelopIds)" [valueField]="'value'" [placeholder]="'Select Explore / Develop'" [clearButton]="false" (valueChange)="handleExploreDevelopIdChange($event)">
            </kendo-combobox>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="AfeApprovalTeam">
              WBS Approval Team
              @if (approvalTeamUrl) {
                <a style="text-decoration-line: underline" [href]="approvalTeamUrl" target="_blank">(view approvers for selected)</a>
              }
            </label>
            <div style="display: flex; gap: 8px;">
              <kendo-combobox id="AfeApprovalTeam" formControlName="AfeApprovalTeam" class="form-control" [data]="AfeApprovalTeamsFiltered" [textField]="'ProjectTeam'" [valueField]="'ProjectTeam'" [placeholder]="'Select WBS Approval Team...'" [clearButton]="false" (valueChange)="handleAfeApprovalTeamSelectChange($event)" [filterable]="true" (filterChange)="handleFilter($event, this.AfeApprovalTeamsData, 'AfeApprovalTeamsFiltered', 'ProjectTeam')">
              </kendo-combobox>
              <button type="button" class="refresh-icon" kendoButton themeColor="primary" [buttonLoading]="refreshClicked" [svgIcon]="icons.refresh" [disabled]="loading || refreshClicked" (click)="refreshAFEApprovalTeams(true)">Refresh</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="ProjectType">Project Type</label>
            <kendo-textbox id="ProjectType" class="k-textbox form-control" [disabled]="true" value="{{dataProject?.ProjectType?.Description}}" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="ProjectSubType">Project Sub Type</label>
            <kendo-combobox id="ProjectSubType" class="form-control" formControlName="ProjectSubType" [data]="dProjectSubType" [textField]="'Description'" [disabledControl]="!(fieldVisibility.ProjectSubType)" [valueField]="'ProjectSubTypeId'" [placeholder]="'Select Project SubType...'" [clearButton]="false" [itemDisabled]="projectSubTypeItemDisabled" (valueChange)="handleProjectSubTypeChange($event)">
            </kendo-combobox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="ConstructionType">{{constructionTypeLabel}}</label>
            <kendo-combobox id="ConstructionType" class="form-control" formControlName="ConstructionType" [data]="constructionTypeOrSequence" [disabledControl]="!(fieldVisibility.ConstructionType)" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select ' + constructionTypeLabel + ' ...'" [clearButton]="false">
            </kendo-combobox>
          </div>
        </div>
        @if (dataProject?.ProjectType?.ProjectTypeId === ProjectTypeId.TankBattery) {
          <div class="col-md-4">
            <div class="form-group">
              <label for="BatteryDesign">Battery Design Type</label>
              <kendo-combobox id="BatteryDesign" class="form-control" formControlName="BatteryDesignTypeIds" [data]="BatteryDesignTypeIds" [textField]="'Description'" [valueField]="'BatteryDesignTypeId'" [placeholder]="'Select Battery Design Type'" [clearButton]="false">
              </kendo-combobox>
            </div>
          </div>
        }
      </div>
      <hr />
      <br />
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="AfeBudget">WBS Amount</label>
            <kendo-numerictextbox id="AfeBudget" [format]="'c0'" class="form-control" [value]="projectEacAndBudgetModel?.AfeBudget ?? null" [disabled]="true" [spinners]="false"></kendo-numerictextbox>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="EACSum">Estimate at Completion</label>
            <kendo-numerictextbox id="EACSum" [format]="'c0'" class="form-control" [value]="projectEacAndBudgetModel?.EACSum ?? null" [spinners]="false" [disabled]="true"></kendo-numerictextbox>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="HookUpVariance">Variance</label>
            <kendo-numerictextbox id="HookUpVariance" [format]="'c0'" class="form-control" [value]="projectVariance" [spinners]="false" [disabled]="true"></kendo-numerictextbox>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="HookUpPercentVariance">Variance %</label>
            <kendo-textbox id="HookUpPercentVariance" type="text" class="k-textbox form-control" [disabled]="true" value="{{projectPctVariance | number:'1.1-1'}}" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="ProjectWorkingInterest">Project Working Interest</label>
            <kendo-numerictextbox id="ProjectWorkingInterest" [step]="1" [min]="0" [max]="1" class="form-control" formControlName="ProjectWorkingInterest" [format]="percentFormat" [spinners]="false" [disabledControl]="!(fieldVisibility.ProjectWorkingInterest)">
            </kendo-numerictextbox>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="NetValue">{{NetValueLabel}}</label>
            <kendo-numerictextbox id="NetValue" class="form-control" [format]="'c'" [step]="1000" [min]="0" [max]="1000000000" formControlName="NetValue" [spinners]="false" [disabledControl]="!(fieldVisibility.NetValue)">
            </kendo-numerictextbox>
          </div>
        </div>
      </div>
      <hr />
      <br />
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="StandardConfiguration">Standard Configuration</label>
            <div class="form-inline">
              <kendo-combobox id="StandardConfiguration" class="col-md-12 form-control" formControlName="StandardConfiguration" [data]="dataSources.StandardConfiguration.filtered" [textField]="'name'" [valueField]="'value'" [placeholder]="'Select Stnd Config...'" [clearButton]="false">
              </kendo-combobox>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <br />
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="ProjectDescription">Project Description</label>
            <textarea id="ProjectDescription" class="form-control" rows="5" formControlName="ProjectDescription"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="Location">Location</label>
            <textarea id="Location" maxlength="250" class="form-control" rows="5" formControlName="Location"></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="Prospect">Prospect</label>
            <kendo-textarea id="Prospect" [maxlength]="250" class="form-control" [rows]="5" formControlName="Prospect" [disabledControl]="!(fieldVisibility.Prospect)"></kendo-textarea>
          </div>
        </div>
      </div>
      <div [hidden]="true">
        <div>
          <input class="k-textbox read-only-value" [attr.disabled]="true" value="{{dataProject?.AssetTeam?.AssetTeamCode}}">
          <div>
            <div class="title-label"> Milestones
              @if (loadingmajormilestonevisibilities) {
                <kendo-loader type="converging-spinner" size="small"></kendo-loader>
              }
            </div>
          </div>
          @if (majormilestonevisibilities && majormilestonevisibilities.length) {
            <div>
              @for (mmvisible of majormilestonevisibilities; track mmvisible) {
                <div class="visiblemajormilestones">
                  <div class="dp-label">{{mmvisible.MajorMilestoneName}}</div>
                  <span class="k-textbox read-only-value">{{mmvisible.Date | date:'short'}}</span>
                </div>
              }
            </div>
          } @else {
            <div class="novisiblemajormilestones">
              @if (!dataProject?.ScheduleId) {
                <span>No Schedule</span>
              } @else {
                No Major Milestones.
              }
            </div>
          }
        </div>
      </div>
    </form>
  </div>
}